import { getAppInfo, downloadUpgradeFile } from './native-interact/native-interface';
import Toast from './components/toast/Toast';
import { getUpgradeInfo } from './service';
import Message from './components/message';
import nativeInterface from './native-interact/native';
import { compareVersion } from './js/utils';

function upgradeAndroid(data) {
  const localAppV = data[0].appVersionCode;
  const localNbV = data[0].appNBVersionCode;

  localStorage.setItem('app_version', localAppV);

  // 获取云端补丁版本信息
  return getUpgradeInfo('ARSC_APP', null, false).then((res) => {
    const version = res.version.split('.');
    const appV = version[0];
    const nbV = version[1];

    if (
      Number(localAppV) < Number(appV)
      || (Number(localAppV) === Number(appV) && Number(localNbV) < Number(nbV))
    ) {
      Message.confirm('App版本较低，需要升级才能支持该页面所有功能，点击确定后开始升级', () => {
        downloadUpgradeFile('app', res.download_url);
        Message.alert('正在下载升级文件，请在升级后重新进入该页面', () => {
          nativeInterface.finishActivity();
        });
      }, () => {
        nativeInterface.finishActivity();
      });
    }
  }).catch((err) => {
    // 针对数据库临时补丁删除后，获取不到版本号，这时通过判断是否支持app补丁升级api判断升级
    if (err.errno !== '402') {
      Toast.fail(err.errtext);
    }
  });
}

function upgradeIOS(data) {
  const localV = data[0].appVersionName;

  // 获取云端补丁版本信息
  return getUpgradeInfo('ARSC_APP_IOS', null, false).then((res) => {
    const version = res.version;

    if (localV && version && compareVersion(version, localV)) {
      Message.confirm('App版本较低，需要升级才能支持该页面所有功能，点击确定后跳转到App Store，请在升级后重新进入该页面', () => {
        nativeInterface.upgradeApp();
        nativeInterface.finishActivity();
      }, () => {
        nativeInterface.finishActivity();
      });
    }
  }).catch((err) => {
    // 针对数据库临时补丁删除后，获取不到版本号，这时通过判断是否支持app补丁升级api判断升级
    if (err.errno !== '402') {
      Toast.fail(err.errtext);
    }
  });
}

// eslint-disable-next-line import/prefer-default-export
export function isAndroid() {
  return !!navigator.userAgent.match(/Android/i);
}

function isIOS() {
  return !!navigator.userAgent.match(/iPhone/i);
}

function upgrade() {
  const android = isAndroid();
  const ios = isIOS();
  if (android || ios) {
    // 获取App本地版本信息
    getAppInfo().then((data) => {
      if (ios) {
        upgradeIOS(data);
      } else if (android) {
        upgradeAndroid(data);
      }
    }).catch(() => {
      if (!('NativeAPI' in window && 'getAppInfo' in window.NativeAPI)) {
        Message.alert('App版本较低，需要升级才能支持该页面所有功能，请手动升级后重新进入该页面', () => {
          nativeInterface.finishActivity();
        });
      }
    });
  }
}

// ios注入原生接口是在页面加载后获取到上下文才能注入（ios需要在页面finished的时候才能注入，这个时候js文件已经加载过一遍），所以确保注入后再调用
window.onload = function () {
  setTimeout(() => {
    upgrade();
  }, 300);
};
